<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Keluarga</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-keluarga><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipEdit" v-b-modal.modal-edit-keluarga @click="dataKeluarga = item">
                <CIcon name="cil-pencil" />
              </b-button>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-keluarga @click="dataKeluarga = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-edit :dataKeluarga="dataKeluarga" @alertFromChild="triggerAlert($event)" />
    <modal-delete :dataKeluarga="dataKeluarga" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  props: ["data"],
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  data() {
    return {
      dataKeluarga: "",
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          _classes: "table-number text-center",
        },
        {
          key: "nama",
          label: "Nama",
          sortDirection: "desc",
          _style: "width: 20%;",
          _classes: "text-left",
        },
        {
          key: "jenisKelamin",
          label: "Jenis Kelamin",
          sortDirection: "desc",
          _style: "width: 15%;",
          _classes: "text-left",
        },
        {
          key: "alamat",
          label: "Alamat",
          sortDirection: "desc",
          _style: "width: 30%;",
          _classes: "text-left",
        },
        {
          key: "statusDalamKeluarga",
          label: "Status Dalam Keluarga",
          sortDirection: "desc",
          _style: "width: 10%;",
          _classes: "text-left",
        },
        {
          key: "namaStatusAsuransi",
          label: "Asuransi",
          sortDirection: "desc",
          _style: "width: 10%;",
          _classes: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          _style: "width: 15%;",
          _classes: "table-option-3 text-center",
          sorter: false,
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getListKeluarga();
      }
    },
    activeTab(newVal) {
      if (newVal === 5) {
        this.getListKeluarga();
      }
    },
  },
  mounted() {},
  methods: {
    async getListKeluarga() {
      let vm = this;
      let listKeluarga = await vm.$axios.post("dataKeluargaKaryawan/listKeluargaByDataKaryawanId", { dataKaryawanId: vm.$route.query.dataKaryawanId });
      // console.log(listKeluarga, "ini respon");
      if (listKeluarga.data.status == 200) {
        vm.items = listKeluarga.data.data.length
          ? listKeluarga.data.data.map((item, idx) => {
              item.no = idx + 1;
              item.tglLahir = vm.$moment(item.tanggalLahir).format("LL");
              item.namaStatusAsuransi = item.statusAsuransi == 0 ? "Inti" : "Lainya";
              return item;
            })
          : [];
      }
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getListKeluarga();
    },
  },
};
</script>
